
<div class="lm-drill-point-list-container form-layout-compact full-height full-width">
  @if (false) {
    <soho-toolbar-flex-section  class="toolbar-section favor title">
      <h2>
        <!--<span *ngIf="selectedNode && selectedNode.lmChildren && selectedNode.lmChildren.length > 0">{{selectedNode.text ? selectedNode.text : selectedNode.badge.text}}</span>-->
        @if (selectedNode && selectedNode.lmChildren && selectedNode.lmChildren.length > 0) {
          <span>{{selectedNode.text}}</span>
        }
        @if (!selectedNode || !selectedNode.lmChildren || selectedNode.lmChildren.length === 0) {
          <span>{{'NoDrillsAvailable' | translate}}</span>
        }
      </h2>
    </soho-toolbar-flex-section>
  }
  <!--
  todo
  - add attributes
  - add id
  - add automation ids
  - data-automation-id="lm-drill-point-data-grid"
  -->
  @if (selectedNode?.children?.length > 0 && gridOptions) {
    <div soho-datagrid
      class="scrollable-flex-content"
      [gridOptions]="gridOptions"
      >
    </div>
  }
</div>
